<template>
    <div class="four-pics-wrap" v-if="has_data" :id="target" ref="picsWrapper" :data-spm="spm">
        <h1 class="four-pics-title" v-if="tag">{{tag}}</h1>
        <div class="four-pics-wrap-inner" ref="picsWrapperInner">
            <ul class="four-pics-list" ref="picsList">
                <li class="pics-item" v-for="(pic, index) in data">
                    <a :href="pic.link ? pic.link : 'javascript:;'" @click.prevent="clickItemHandler(index)" ref="pics">
                        <img class="pics-image" :src="pic.imageUrl" alt="">
                        <footer class="pics-title">{{pic.title}}</footer>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import nativeUtil from '../_utils/native-util.js'

    export default {
        name: 'FourPics',
        props: {
            target: {
                default: '',
                type: String
            },
            data: {
                type: Array,
                default : () => [],
            },
            // spm码
            spm: {
                default: '',
                type: String,
            },
            tag: {
                default: '',
                type: String,
            }
        },
        data() {
            return {
            }
        },
        computed: {
            has_data(){
                return this.data.length > 0
            }
        },
        methods: {
            hideScrollBar() {
                // 10px 是css中血丝用来隐藏滚动条的，不根据屏幕尺寸变化
                const maxHeight = this.$refs.picsList.offsetHeight - 10
                this.$refs.picsWrapperInner.style.maxHeight = maxHeight + 'px'
            },
            clickItemHandler(index) {
                const pics = this.$refs.pics
                const url = pics[index].getAttribute('href')
                nativeUtil.openContent(url, this.data[index])
            }
        },
        mounted() {
            this.hideScrollBar()
        }
    }
</script>

<style scoped lang="less">
    .four-pics-wrap {
        padding: 10px 0;
        overflow: hidden;
        .four-pics-title {
            margin: 2px 0 11px 11px;
            font-size: 17px; /*no*/
            font-weight: bold;
            color: #222222;
        }
        .four-pics-wrap-inner {
            overflow: hidden;
        }
        .four-pics-list {
            display: -webkit-box;
            height: 100%;
            padding-bottom: 10px;  /*no*/
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
            .pics-item {
                width: 152px;
                margin-right: 5px;
                overflow: hidden;
                &:first-child {
                    padding-left: 15px;
                }
                &:last-child {
                    padding-right: 15px;
                }
                .pics-image {
                    width: 100%;
                    height: 97px;
                }
                .pics-title {
                    margin-top: 9px;
                    font-size: 15px;
                    color: #656565;
                    line-height: 21px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FourPics.vue